module.exports = __webpack_public_path__ + "pf.svg?b5477fd9e505c34b7480fa7aecab3e2e";